<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

    <div class="row">
      <div class="col-lg-2">
        <div class="ibox ">
          <div class="ibox-title">
            <span class="label label-success float-right">Monthly</span>
            <h5>Sign Up</h5>
          </div>
          <div class="ibox-content">
            <h1 class="no-margins">6,228</h1>
            <div class="stat-percent font-bold text-success">9% <i class="fa fa-bolt"></i></div>
            <small>Total monthly sign up</small>
          </div>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="ibox ">
          <div class="ibox-title">
            <span class="label label-info float-right">Monthly</span>
            <h5>Active Users</h5>
          </div>
          <div class="ibox-content">
            <h1 class="no-margins">80,800</h1>
            <div class="stat-percent font-bold text-info">13% <i class="fa fa-level-up"></i></div>
            <small>New active users</small>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="ibox ">
          <div class="ibox-title">
            <span class="label label-primary float-right">Today</span>
            <h5>Movements</h5>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-md-6">
                <h1 class="no-margins">40,642</h1>
                <div class="font-bold text-navy">44% <i class="fa fa-level-up"></i> <small>Tenant</small></div>
              </div>
              <div class="col-md-6">
                <h1 class="no-margins">20,612</h1>
                <div class="font-bold text-navy">22% <i class="fa fa-level-up"></i> <small>Non-Tenant</small></div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="ibox ">
          <div class="ibox-title">
            <h5>Monthly income</h5>
            <div class="ibox-tools">
              <span class="label label-primary">Updated 10.2018</span>
            </div>
          </div>
          <div class="ibox-content no-padding">
            <div class="flot-chart m-t-lg" style="height: 55px;">
              <div class="flot-chart-content" id="flot-chart1"></div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="ibox ">
          <div class="ibox-content">
            <div>
              <span class="float-right text-right">
                <small>Average value of sales in the past month in: <strong>Malaysia</strong></small>
                <br />
                All sales: 162,862
              </span>
              <h3 class="font-bold no-margins">
                Revenue
              </h3>
              <small>Sales marketing.</small>
            </div>

            <div class="m-t-sm">

              <div class="row">
                <div class="col-md-8">
                  <div>
                    <canvas id="lineChart" height="114"></canvas>
                  </div>
                </div>
                <div class="col-md-4">
                  <ul class="stat-list m-t-lg">
                    <li>
                      <h2 class="no-margins">80,800</h2>
                      <small>Active User in last month</small>
                      <div class="progress progress-mini">
                        <div class="progress-bar" style="width: 48%;"></div>
                      </div>
                    </li>
                    <li>
                      <h2 class="no-margins ">6,228</h2>
                      <small>Sign up in last month</small>
                      <div class="progress progress-mini">
                        <div class="progress-bar" style="width: 60%;"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

            </div>

            <div class="m-t-md">
              <small class="float-right">
                <i class="fa fa-clock-o"> </i>
                Update on 31.07.2018
              </small>
              <small>
                <!-- <strong>Analysis of sales:</strong> The value has been changed over time, and last month reached a
                level over RM 50,000. -->
              </small>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="ibox ">
          <div class="ibox-title">
            <span class="label label-warning float-right">Data has changed</span>
            <h5>Car Park</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-4">
                <small class="stats-label">Testing Car Park A</small>
                <h4>36,455</h4>
              </div>

              <div class="col-4">
                <small class="stats-label">% Movement</small>
                <h4>+19.13%</h4>
              </div>
              <div class="col-4">
                <small class="stats-label">Previous Month</small>
                <h4>28,992</h4>
              </div>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-4">
                <small class="stats-label">Testing Car Park B</small>
                <h4>41,368</h4>
              </div>

              <div class="col-4">
                <small class="stats-label">% Movement</small>
                <h4>-7.15%</h4>
              </div>
              <div class="col-4">
                <small class="stats-label">Previous Month</small>
                <h4>44.554</h4>
              </div>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-4">
                <small class="stats-label">Testing Car Park C</small>
                <h4>36,647</h4>
              </div>

              <div class="col-4">
                <small class="stats-label">% Movement</small>
                <h4>+4.52%</h4>
              </div>
              <div class="col-4">
                <small class="stats-label">Previous Month</small>
                <h4>34,990</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-lg-12">
        <div class="ibox ">
          <div class="ibox-title">
            <h5>Latest Unpaid Bills</h5>
            <div class="ibox-tools">
              <a class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </a>
              <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                <i class="fa fa-wrench"></i>
              </a>
              <!-- <ul class="dropdown-menu dropdown-user">
                <li><a href="#" class="dropdown-item">Config option 1</a>
                </li>
                <li><a href="#" class="dropdown-item">Config option 2</a>
                </li>
              </ul>
              <a class="close-link">
                <i class="fa fa-times"></i>
              </a> -->
            </div>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-sm-9 m-b-xs">
                <!-- <div data-toggle="buttons" class="btn-group btn-group-toggle">
                  <label class="btn btn-sm btn-white"> <input type="radio" id="option1" name="options"> Day </label>
                  <label class="btn btn-sm btn-white active"> <input type="radio" id="option2" name="options"> Week
                  </label>
                  <label class="btn btn-sm btn-white"> <input type="radio" id="option3" name="options"> Month </label>
                </div> -->
              </div>
              <div class="col-sm-3">
                <div class="input-group mb-3">
                  <input type="text" class="form-control form-control-sm" placeholder="Search">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-primary" type="button">Go!</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>

                    <th>#</th>
                    <th>Parker Name </th>
                    <th>Phone </th>
                    <th>Company </th>
                    <th>Bill Date</th>
                    <th>Bill Amount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Testing 017</td>
                    <td>015 127 1388</td>
                    <td>Testing 04 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>200.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Testing 212</td>
                    <td>015 261 9922</td>
                    <td>Testing 09 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>170.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Testing 093</td>
                    <td>015 331 3784</td>
                    <td>Testing 10 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>340.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Testing 044</td>
                    <td>015 165 2883</td>
                    <td>Testing 02 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>70.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Testing 238</td>
                    <td>015 172 2991</td>
                    <td>Testing 03 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>100.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Testing 002</td>
                    <td>015 271 3994</td>
                    <td>Testing 07 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>320.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Testing 288</td>
                    <td>015 812 2883</td>
                    <td>Testing 06 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>110.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Testing 201</td>
                    <td>015 228 1927</td>
                    <td>Testing 05 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>200.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Testing 183</td>
                    <td>015 337 1992</td>
                    <td>Testing 01 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>110.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Testing 113</td>
                    <td>015 349 1623</td>
                    <td>Testing 08 Company Sdn Bhd</td>
                    <td>Nov 15, 2018</td>
                    <td>130.00</td>
                    <td><a href="#"><i class="fa fa-check text-navy"></i></a></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

    </div>

    <link href="css/plugins/morris/morris-0.4.3.min.css" rel="stylesheet">

    <!-- TODO need proper way to include script only for this page -->

  </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import helper from "@/components/Utility/Helper"

export default {
  name: "PageDashboard",
  data () {
    return {
      permission : null,
      breadcrumb : null,
    }
  },
  components: {
    TemplateBasic,
    TemplateButton,
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
    
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    var script = document.createElement( "script" )
    script.setAttribute('src', '/static/js/plugins/jquery-ui/jquery-ui.min.js')
    script.type = "text/javascript";

    let self = this;
    if(script.readyState) {  //IE
      script.onreadystatechange = function() {
        if ( script.readyState === "loaded" || script.readyState === "complete" ) {
          script.onreadystatechange = null;
          self.onJqueryMinLoaded();
        }
      };
    } else {  //Others
      script.onload = function() {
        self.onJqueryMinLoaded();
      };
    }

    document.head.appendChild(script)
  },
  methods: {
    createScript(url) {
      const script = document.createElement('SCRIPT');
      script.setAttribute('src', url)
      document.head.appendChild(script)
    },
    onJqueryMinLoaded() {
      this.createScript("static/js/demo/peity-demo.js");
      this.createScript("static/js/demo/sparkline-demo.js");
      this.createScript("static/js/dashboard.js");
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Page/PageDashboard.vue